/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientWorkspaceDto } from '../../models/client-workspace-dto';
import { CreateClientWorkspaceDto } from '../../models/create-client-workspace-dto';

export interface ClientWorkspaceControllerCreate$Params {
  vendorWorkspaceId: string;
      body: CreateClientWorkspaceDto
}

export function clientWorkspaceControllerCreate(http: HttpClient, rootUrl: string, params: ClientWorkspaceControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientWorkspaceDto>> {
  const rb = new RequestBuilder(rootUrl, clientWorkspaceControllerCreate.PATH, 'post');
  if (params) {
    rb.path('vendorWorkspaceId', params.vendorWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientWorkspaceDto>;
    })
  );
}

clientWorkspaceControllerCreate.PATH = '/api/clientWorkspace/{vendorWorkspaceId}';
